import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_FULL_SUNRISE = defineFcm('petition_page_full_sunrise')
	.asJson(
		createShapeNormalizer({
			type: 'record',
			// Include any module that will be experimented on in the full sunrise migration
			keys: [
				'petitionDescription',
				'supporterVoices',
				'petitionHeading',
				'sharePetition',
				'petitionUpdates',
				'promotedPetitions',
			] as const,
			shape: {
				type: 'object',
				optional: true,
				shape: {
					enabled: { type: 'boolean' },
					experimentName: { type: 'string' },
				},
			},
		}),
	)
	.withDefault({
		petitionDescription: { enabled: true, experimentName: '' },
		supporterVoices: { enabled: false, experimentName: '' },
	})
	.toConfig();
